import { useState } from "react";
import { toast } from "sonner";
import { CalendarClock, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

// Coach/admin moves a whole requested group session to a new time.
export function GroupReschedule({ bookingId, onDone }) {
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      await api.post(`/group-bookings/${bookingId}/reschedule`, { new_start: val });
      toast.success("Group session moved — everyone has been notified");
      setVal("");
      onDone?.();
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Couldn't reschedule"); }
    finally { setBusy(false); }
  };
  return (
    <div className="card-surface p-6 space-y-3" data-testid="gb-reschedule">
      <div className="label-mono inline-flex items-center gap-2"><CalendarClock className="w-3.5 h-3.5 text-[#CCFF00]" /> RESCHEDULE GROUP</div>
      <p className="text-xs text-[#A3A3A3]">Moves the whole group together. Payments already made carry over.</p>
      <div className="flex flex-wrap items-center gap-2">
        <input type="datetime-local" value={val} onChange={(e) => setVal(e.target.value)} data-testid="gb-reschedule-input"
          className="bg-[#141414] border border-[#262626] focus:border-[#CCFF00] focus:outline-none p-2 text-sm" />
        <button type="button" onClick={go} disabled={busy || !val} data-testid="gb-reschedule-confirm"
          className="min-h-[40px] px-4 py-2 text-xs uppercase tracking-wider font-bold bg-[#CCFF00] text-black inline-flex items-center gap-1.5 disabled:opacity-40">
          {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Move group
        </button>
      </div>
    </div>
  );
}
